/**
 * @license
 * Copyright 2026 okayest! studios LLC. All Rights Reserved.
 */

import '@awesome.me/webawesome/dist/styles/themes/default.css';
import { registerIconLibrary } from '@awesome.me/webawesome/dist/webawesome.js';

import './row-counter/components/row-counter';

registerIconLibrary('default', {
  resolver: (name) => `/img/icons/${name}.svg`,
});
